const transferStatus = require('./transferStatus');
const batchStatus = require('./batchStatus');

module.exports = {
  [batchStatus.DRAFT]: {
    CREATED: transferStatus.CREATED,
    FAILED: transferStatus.FAILED,
    WARNING: 'ALERTA'
  },
  [batchStatus.RECEIVED]: {
    RECEIVED: transferStatus.RECEIVED,
    FAILED: transferStatus.FAILED,
    REQUESTED_REFUND: transferStatus.REQUESTED_REFUND,
    BEING_RETURNED: transferStatus.BEING_RETURNED,
    RETURNED: transferStatus.RETURNED,
    TRANSFERRED: [transferStatus.TRANSFERRED, transferStatus.FINISHED],
    SCHEDULED: transferStatus.SCHEDULED
  },
  [batchStatus.FINISHED]: {
    FINISHED: transferStatus.FINISHED,
    RETURNED: transferStatus.RETURNED
  }
};
